import { useState, useEffect } from "react";
import { getSales } from "../../utils/api/getSales.js";

export function ProfilePage4(user) {


  const [sales, setSales] = useState([])

  useEffect(() => {
    // cargar datos de usuario
    loadSales();
  }, []);

  const loadSales = async () => {
    const loadedSales = await getSales(user);

    console.log(loadedSales.data)
    
    setSales(loadedSales.data)

  }

 
  return (
    <>

      <div className="m-layMiCuenta__body">
        <div className="bx">
          <header>
            <br/>
            <span className="ht-body-bold uppercase" >Mis compras</span><br/>
            <span className="ht-body-regular">Consulte sus compras y descarge sus tickets</span>
          </header>

          <div className="m-frmGroup">
            <div className="m-tableInvoice">
              <div className="m-tableInvoice__head">
                <div className="">Id. Compra</div>
                <div className="">Fecha de compra</div>
                <div className="">Fecha de viaje</div>
                <div className="">Precio</div>
                <div className="">Naviera</div>
                <div className="">Localizador</div>
                <div className=""></div>
              </div>
              { sales.map((element) => ( 
                <>
                    <div className="m-tableInvoice__body">
                      <div className="m-tableInvoice__input">
                        <div> <span>Id. Compra</span> {element.id}</div>
                        <div> <span>Fecha de compra</span> {element.created_at}</div>
                        <div> <span>Fecha de viaje</span> {element.outward_day}</div>
                        <div> <span>Precio</span> {element.amount}</div>
                        <div> <span>Naviera</span> {element.company}</div>
                        <div> <span>Localizador</span> {element.booking_number}</div>
                        <div> <a className="pdf_link" href="/pdf/432483?locale=es">pdf</a></div>
                      </div>
                    </div>
                
                </>)) }
             
            </div>
          </div>
        </div>
      </div>
    </>
  )
}